import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkUpdateServiceAreaStatusByIds } from '../../../api/plan-service-area-override-rules-api'
import type { BulkUpdateServiceAreaStatusByIdsRequestDto } from '../../../api/dto/plan-service-area-override-rules.dto'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'

export function useBulkUpdateServiceAreaStatusByIds() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, BulkUpdateServiceAreaStatusByIdsRequestDto>(
    {
      mutationFn: (body) => bulkUpdateServiceAreaStatusByIds(body),
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
        })
      },
    }
  )
}
